export default __webpack_public_path__ + "static/media/php-svgrepo-com.86250ddb.svg";